import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { dramas } from "@/mocks/dramas";

const slides = [
  {
    id: "chang-ye-jiang-ming",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20film%20still%20of%20a%20rain-soaked%20city%20alley%20at%20night%2C%20wet%20asphalt%20reflecting%20warm%20amber%20streetlights%2C%20dense%20fog%20and%20deep%20ink%20black%20shadows%20in%20the%20background%2C%20one%20silhouette%20holding%20an%20umbrella%2C%20moody%20mystery%20thriller%20atmosphere%2C%20subtle%20film%20grain%2C%20no%20text%2C%20wide%20editorial%20composition&width=1600&height=900&seq=hero-changye-night&orientation=landscape",
    eyebrow: "本周焦点 · 悬疑口碑榜首",
    note: "双时间线叙事，每一帧都在修正记忆",
  },
  {
    id: "jin-xiu-chun-qiu",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20film%20still%20of%20an%20ancient%20Chinese%20palace%20courtyard%20at%20dusk%2C%20rows%20of%20glowing%20red%20lanterns%20and%20layered%20silk%20curtains%2C%20warm%20golden%20light%20on%20dark%20wood%20architecture%2C%20deep%20charcoal%20shadows%2C%20elegant%20historical%20drama%20atmosphere%2C%20fine%20film%20grain%2C%20no%20text%2C%20wide%20editorial%20composition&width=1600&height=900&seq=hero-jinxiu-palace&orientation=landscape",
    eyebrow: "古装权谋 · 编辑长评推荐",
    note: "把朝堂的刀光藏在一针一线里",
  },
  {
    id: "wu-jian-zhi-cheng",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20film%20still%20of%20a%20foggy%20harbor%20town%20at%20dawn%2C%20thick%20sea%20mist%20covering%20wooden%20piers%20and%20fishing%20boats%2C%20warm%20amber%20harbor%20lamps%20glowing%20through%20the%20grey%20fog%2C%20deep%20moody%20shadows%2C%20mysterious%20cinematic%20atmosphere%2C%20film%20grain%2C%20no%20text%2C%20wide%20editorial%20composition&width=1600&height=900&seq=hero-wujian-harbor&orientation=landscape",
    eyebrow: "迷雾科幻 · 追剧党热议",
    note: "海雾封城第七天，记忆开始错位",
  },
];

export default function HeroCarousel() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const timer = window.setInterval(() => {
      setIndex((prev) => (prev + 1) % slides.length);
    }, 7000);
    return () => window.clearInterval(timer);
  }, []);

  const activeDrama = dramas.find((item) => item.id === slides[index].id);
  const activeSlide = slides[index];

  const goPrev = () => setIndex((prev) => (prev - 1 + slides.length) % slides.length);
  const goNext = () => setIndex((prev) => (prev + 1) % slides.length);

  return (
    <section className="relative h-[620px] w-full overflow-hidden bg-background-50 md:h-[700px]">
      {slides.map((slide, i) => (
        <div
          key={slide.id}
          className={`absolute inset-0 transition-opacity duration-1000 ${
            i === index ? "opacity-100" : "opacity-0"
          }`}
          aria-hidden={i !== index}
        >
          <img
            src={slide.image}
            alt={`${slide.eyebrow} 焦点剧照`}
            title="热门剧集焦点剧照"
            className={`h-full w-full object-cover ${i === index ? "animate-slow-zoom" : ""}`}
          />
          <div className="absolute inset-0 bg-gradient-to-r from-background-50 via-background-50/78 to-background-50/25"></div>
          <div className="absolute inset-0 bg-gradient-to-t from-background-50 via-background-50/10 to-background-50/45"></div>
        </div>
      ))}

      <div className="relative mx-auto flex h-full w-full max-w-[1240px] flex-col justify-end px-4 pb-14 pt-28 md:px-6 md:pb-20">
        {activeDrama && (
          <div key={activeSlide.id} className="animate-rise">
            <span className="inline-flex items-center gap-2 rounded-full border border-accent-500/40 bg-background-50/70 px-3.5 py-1.5 font-label text-[11px] tracking-[0.18em] text-accent-500">
              <span className="h-1.5 w-1.5 rounded-full bg-accent-500"></span>
              {activeSlide.eyebrow}
            </span>

            <h2 className="mt-5 max-w-3xl font-heading text-4xl font-semibold leading-[1.15] text-foreground-950 md:text-6xl">
              {activeDrama.title}
            </h2>

            <div className="mt-4 flex flex-wrap items-center gap-x-4 gap-y-2 font-label text-xs text-foreground-600 md:text-sm">
              <span className="flex items-center gap-1.5 text-accent-500">
                <i className="ri-star-fill text-xs"></i>
                {activeDrama.rating.toFixed(1)}
              </span>
              <span className="h-3 w-px bg-background-300/60"></span>
              <span>{activeDrama.year}</span>
              <span>{activeDrama.region}</span>
              <span>{activeDrama.episodeCount} 集</span>
              <span className="rounded-full bg-primary-500/15 px-2.5 py-0.5 text-primary-500">
                {activeDrama.types.join(" · ")}
              </span>
            </div>

            <p className="mt-4 max-w-xl text-sm leading-relaxed text-foreground-700 md:text-[15px]">
              {activeDrama.synopsis}
            </p>
            <p className="mt-3 max-w-xl font-label text-xs text-secondary-900 md:text-[13px]">
              {activeSlide.note}
            </p>

            <div className="mt-7 flex flex-wrap items-center gap-3">
              <Link
                to={`/detail/${activeDrama.id}`}
                className="flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-3 font-label text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                <i className="ri-play-circle-line text-base"></i>
                查看剧情详情
              </Link>
              <Link
                to="/category"
                className="flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md border border-foreground-800/25 bg-background-50/40 px-5 py-3 font-label text-sm text-foreground-800 transition-colors hover:border-accent-500/60 hover:text-accent-500"
              >
                浏览全部剧集
                <i className="ri-arrow-right-line text-sm"></i>
              </Link>
            </div>
          </div>
        )}

        <div className="mt-9 flex items-end justify-between gap-6">
          <div className="flex items-center gap-2.5">
            {slides.map((slide, i) => (
              <button
                key={slide.id}
                type="button"
                aria-label={`切换到第 ${i + 1} 张焦点图`}
                onClick={() => setIndex(i)}
                className={`h-1.5 cursor-pointer rounded-full transition-all duration-300 ${
                  i === index ? "w-9 bg-primary-500" : "w-4 bg-foreground-800/30 hover:bg-foreground-800/60"
                }`}
              ></button>
            ))}
            <span className="ml-2 font-label text-[11px] tracking-[0.2em] text-foreground-600">
              0{index + 1} / 0{slides.length}
            </span>
          </div>

          <div className="flex items-center gap-2">
            <button
              type="button"
              onClick={goPrev}
              aria-label="上一张"
              className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-full border border-foreground-800/25 text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-500"
            >
              <i className="ri-arrow-left-s-line text-lg"></i>
            </button>
            <button
              type="button"
              onClick={goNext}
              aria-label="下一张"
              className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-full border border-foreground-800/25 text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-500"
            >
              <i className="ri-arrow-right-s-line text-lg"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}